
const lastUpdate = '2026-09-30';
export const helpTitle = 'GIS Data Download';

export const helpContent = `
<h1>${helpTitle}</h1>

<h2>Overview</h2>
<p>The GIS Data Download tool exports EasyMap data layers in standard GIS formats for use in desktop GIS software or external analysis.</p>

<h2>How It Works</h2>
<ol>
  <li><strong>Choose a format</strong> from the three options below.</li>
  <li><strong>Select datasets</strong> to include — all are selected by default. Use the category checkboxes to toggle a group (Operational, Values at Risk, Aircraft) together, or pick individual layers.</li>
  <li><strong>Click Export</strong> to download a single archive containing every selected dataset.</li>
</ol>

<h2>Available Datasets</h2>
<p><strong>Operational</strong></p>
<ul>
  <li><strong>Wildfires</strong> — current and historical fire points.</li>
  <li><strong>Lightning Strikes (72hr)</strong> — strike points from the last 72 hours.</li>
  <li><strong>Fire Perimeters (Current Year)</strong> — perimeter polygons for active and recent fires.</li>
  <li><strong>Weather Stations</strong> — station locations and attributes.</li>
</ul>
<p><strong>Values at Risk</strong></p>
<ul>
  <li><strong>VAR Points</strong> — point features (cabins, sites).</li>
  <li><strong>VAR Areas</strong> — polygon features (traplines).</li>
  <li><strong>VAR Lines</strong> — line features (transmission, fiber).</li>
</ul>
<p><strong>Aircraft</strong> (shown only if you have the AFF export permission)</p>
<ul>
  <li><strong>Aircraft (AFF)</strong> — each tracked aircraft at its latest position.</li>
  <li><strong>Aircraft Tracks (AFF, 72hr)</strong> — track points from the last 72 hours, with the aircraft each was flown in.</li>
</ul>

<h2>Export Formats</h2>
<ul>
  <li><strong>Shapefile (NWT Lambert, EPSG:3580)</strong> — projected meters. <strong>Recommended for area and distance calculations</strong> in the NWT.</li>
  <li><strong>Shapefile (WGS 84, EPSG:4326)</strong> — ESRI shapefile in lat/lon. Use for general-purpose GIS work.</li>
  <li><strong>GeoJSON (WGS 84, EPSG:4326)</strong> — standard web GIS format. Compatible with most modern tools.</li>
</ul>

<h2>Coordinate Columns</h2>
<p>Most features include <strong>DDMLAT</strong> and <strong>DDMLON</strong> columns containing the feature's coordinates in Degrees Decimal Minutes format. For non-point features, the DDM columns reflect a representative point.</p>
<p><em>Exception:</em> VAR Areas and VAR Lines come from GeoServer and do not include DDM columns.</p>

<div class="last-update">Last Updated: ${lastUpdate}</div>
`;

export default helpContent;
